module.exports = __webpack_public_path__ + "static/img/favicon.64821460.png";